import { IFormRender, SelectFormField } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from 'types/ClassName';
import { AnyObject } from 'types/util/Object';
import { getTimeOffTypeDefinition } from 'utils/constants/timeOffType';
import { t } from 'utils/localize';
import { useOrganizationTimeOffSettings } from 'utils/organization/timeOffSettings/useTimeOffSettings';
import { v_require } from 'utils/validations';

export interface ITTimeOffTypeSelectFormFieldProps<FormType extends AnyObject> {
  className?: ClassName;
  form: IFormRender<FormType>;
  name: string;
  placeholder: string;
}

const TimeOffTypeSelectFormField = <FormType extends AnyObject>(props: ITTimeOffTypeSelectFormFieldProps<FormType>) => {
  const { className, form, name, placeholder } = props;

  const timeOffOptions = useOrganizationTimeOffSettings();

  const classes = classNames(
    {
      'time-off-type-select-form-field': true,
    },
    className
  );

  return (
    <SelectFormField
      className={classes}
      name={name}
      form={form}
      placeholder={placeholder}
      validations={[{ validation: v_require }]}
      options={timeOffOptions.active.map((type, i) => ({
        value: type,
        label: t(getTimeOffTypeDefinition(timeOffOptions.active[i], timeOffOptions).label),
      }))}
    />
  );
};

export default TimeOffTypeSelectFormField;
